import { render, staticRenderFns } from "./SiteSuperintendent.vue?vue&type=template&id=08385500&scoped=true"
import script from "./SiteSuperintendent.vue?vue&type=script&lang=js"
export * from "./SiteSuperintendent.vue?vue&type=script&lang=js"
import style0 from "./SiteSuperintendent.vue?vue&type=style&index=0&id=08385500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08385500",
  null
  
)

export default component.exports